var exports = {
  "A": "diffEntry__YLOXdm",
};

module.exports = exports;
